/* eslint-disable react/jsx-props-no-spreading */
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IconButton from '@base/IconButton/IconButton';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings, Fonts } from '@styles/index';

const StyledIconButton = styled(IconButton)`
  box-shadow: ${({ $dropShadow }) =>
    $dropShadow ? boxShadowGenerator() : 'none'};
`;

const EnrollButtonWrapper = styled.div`
  position: absolute;
  right: ${Spacings.SPACING_4B};
  top: ${Spacings.SPACING_4B};
  display: flex;
  &:hover > div:first-child {
    width: ${({ $tagWidth, $disableHover }) =>
      $disableHover ? '0px' : $tagWidth};
  }
  ${({ $dropShadow }) =>
    $dropShadow ? `box-shadow: ${boxShadowGenerator()}` : ''}
  border-radius: 8px;
`;

const EnrollStatusTag = styled.div`
  width: 0px;
  height: 32px;
  z-index: 1;
  background-color: var(--color-base-1);
  margin-right: -7px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  color: var(--color-text-primary);
  font-weight: ${Fonts.SEMIBOLD};
  line-height: 32px;
  padding: 0;
  transition: width 300ms ease-out;
  white-space: nowrap;
  overflow: hidden;
  ${({ $dropShadow }) =>
    $dropShadow ? `box-shadow: ${boxShadowGenerator()}` : ''}
`;

const EnrollStatusLabel = styled.div`
  width: ${({ $tagWidth }) => $tagWidth};
  padding: 0 ${Spacings.SPACING_6};
  float: right;
`;

const EnrollButton = ({
  iconProps,
  children,
  isEnrolled,
  onClick,
  statusTags,
  dropShadow,
  disableHover,
  dataAnalytics
}) => {
  const enrolled = isEnrolled ?? false;
  return (
    <EnrollButtonWrapper
      onClick={onClick}
      $tagWidth={statusTags[enrolled].width}
      $dropShadow={dropShadow}
      $disableHover={disableHover}
      data-analytics={dataAnalytics}
      data-testid="enroll-button"
    >
      <EnrollStatusTag $dropShadow={dropShadow}>
        <EnrollStatusLabel>{statusTags[enrolled].label}</EnrollStatusLabel>
      </EnrollStatusTag>
      <StyledIconButton $dropShadow={dropShadow} {...iconProps}>
        {children}
      </StyledIconButton>
    </EnrollButtonWrapper>
  );
};

EnrollButton.propTypes = {
  iconProps: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.node.isRequired,
  isEnrolled: PropTypes.bool,
  onClick: PropTypes.func,
  statusTags: PropTypes.objectOf(PropTypes.object),
  dropShadow: PropTypes.bool,
  disableHover: PropTypes.bool,
  dataAnalytics: PropTypes.string
};

EnrollButton.defaultProps = {
  iconProps: {},
  onClick: undefined,
  isEnrolled: false,
  statusTags: {
    true: {
      label: 'UNENROLL',
      width: '80px'
    },
    false: {
      label: 'ENROLL',
      width: '62px'
    }
  },
  dropShadow: false,
  disableHover: false,
  dataAnalytics: ''
};

export default EnrollButton;
